import { render } from "./DeviceUserList.vue?vue&type=template&id=8736b5a0&scoped=true"
import script from "./DeviceUserList.vue?vue&type=script&lang=js"
export * from "./DeviceUserList.vue?vue&type=script&lang=js"

import "./DeviceUserList.vue?vue&type=style&index=0&id=8736b5a0&scoped=true&lang=css"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8736b5a0"]])

export default __exports__